import { TableName } from '../../constants/table';
import { doesEntityExist } from '../../lib/services/api-service';

export const validateTenants = async (
  tenantId: string,
  value: string
): Promise<boolean> => {
  const exists = await doesEntityExist(TableName.Tenant, tenantId, value);
  return !exists;
};
